import { forwardRef } from "react"
import { mergeClasses } from "@lib/css"

import type { IconProps } from "./types"

export const IconStar = forwardRef<SVGSVGElement, IconProps>(function IconStar(
  props,
  ref,
) {
  const { className, title, titleId, ...otherProps } = props
  const defaultClasses =
    "w-5.5 h-5.5 inline-flex flex-shrink-0 fill-current transition-colors duration-150 ease-in focus:outline-none"
  const classes = mergeClasses(defaultClasses, className)

  return (
    <svg
      ref={ref}
      viewBox="0 0 22 20"
      focusable="false"
      aria-hidden="true"
      tabIndex={-1}
      className={classes}
      aria-labelledby={titleId}
      {...otherProps}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path d="M11 0L13.4697 7.60081H21.4616L14.996 12.2984L17.4656 19.8992L11 15.2016L4.53436 19.8992L7.00401 12.2984L0.538376 7.60081H8.53034L11 0Z" />
    </svg>
  )
})
